import { Box, Grid, styled, Typography } from "@mui/material";
import React from "react";
import appcolors from "../../../constants/Colors";
import { allImages } from "../../../assets";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1100px",
  margin: "auto",
  padding: "16px",

  "& .lpl_rs_pr": {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "#161C2D",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  "& .lpl_rs_sr": {
    fontSize: "1.8rem",
    fontWeight: 600,
    color: "#161C2D",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
  },
}));

const joinSteps = [
  {
    step: 1,
    description:
      "Search and find out best salon and service related your requirements just click on it",
  },
  {
    step: 2,
    description: "All spa and salon will show based on your location.",
  },
  {
    step: 3,
    description: "More you can see all details related B2B business.",
  },
];

function BookingViaDb() {
  const renderSteps = () => {
    return joinSteps?.map((val, ind) => {
      return (
        <Box mt={3} key={ind}>
          <Typography variant="h1" className="lpl_rs_sr">
            Step {val.step}
          </Typography>
          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
          >
            {val.description}{" "}
            {val.step == 1 && (
              <span style={{ fontWeight: "bold", color: appcolors.primary }}>
                LOBA{" "}
              </span>
            )}
          </Typography>
        </Box>
      );
    });
  };
  return (
    <MainView my={{ xs: 3, md: 6 }}>
      <Grid container spacing={{ xs: 2, md: 4 }}>
        <Grid item xs={12} md={6}>
          <img src={allImages.landingJoinviadb} alt={"image"} width={"100%"} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h1" className="lpl_rs_pr">
            1- Dashboard
          </Typography>
          <Typography variant="h1" className="lpl_rs_pr">
            Just start booking..{" "}
          </Typography>
          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
          >
            "Our app's dashboard displays all available spa, salon, and B2B
            shops for easy booking. Quickly browse and select the best options
            for your needs with a user-friendly interface."
          </Typography>
          <Typography
            variant="body1"
            color={"primary.main"}
            fontStyle={"italic"}
          >
            Download application form app store & play store.
          </Typography>
          {renderSteps()}
        </Grid>
      </Grid>
    </MainView>
  );
}

export default BookingViaDb;
